import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';

export const PROPERTY_COLUMN_MATCH_SEGMENT = '.properties.';

/** Backend effective display Name: COALESCE(join aliases…, item Name) as `{uuid}.display.Name`. */
export const DISPLAY_NAME_COLUMN_MATCH_SEGMENT = '.display.';

export const UOM_COLUMN_MATCH_SUFFIX = '_uom';

/** Trailing suffix of a display-Name logical column (`{uuid}.display.Name`). */
export const DISPLAY_NAME_COLUMN_SUFFIX = `${DISPLAY_NAME_COLUMN_MATCH_SEGMENT}${SeeqNames.Properties.Name}`;

/**
 * Parses `{uuidColumn}.display.Name` by matching a trailing `.display.Name` so UUID columns that themselves
 * contain `.display.` (e.g. `foo.display.bar.display.Name`) resolve correctly. Returns the UUID column or null.
 */
export const parseDisplayNameColumnName = (logicalName: string): string | null => {
  const lowerName = logicalName.toLowerCase();
  const lowerSuffix = DISPLAY_NAME_COLUMN_SUFFIX.toLowerCase();
  if (!lowerName.endsWith(lowerSuffix)) {
    return null;
  }
  const uuidColumn = logicalName.substring(0, logicalName.length - DISPLAY_NAME_COLUMN_SUFFIX.length);
  return uuidColumn.length > 0 ? uuidColumn : null;
};
